/**
 * components/MapperToolbar.tsx - Mapper Toolbar Component
 * 
 * CHANGE HISTORY:
 * - 251103_1046 [pending] danielbeer: Initial MapperToolbar component
 * 
 * Toolbar with actions for the Visual Mapper.
 */

import React from 'react';
import type { ValidationResult } from '../types';

export interface MapperToolbarProps {
  onAutoMatch: () => void;
  onClearAll: () => void;
  onValidate: () => void;
  isAutoMatching: boolean;
  validation?: ValidationResult;
  mappingCount: number;
  theme?: 'light' | 'dark';
}

export const MapperToolbar: React.FC<MapperToolbarProps> = ({
  onAutoMatch,
  onClearAll,
  onValidate,
  isAutoMatching,
  validation,
  mappingCount,
  theme = 'light'
}) => {
  return (
    <div className={`mapper-toolbar mapper-toolbar--${theme}`}>
      <div className="mapper-toolbar__left">
        <button
          className="mapper-toolbar__button"
          onClick={onAutoMatch}
          disabled={isAutoMatching}
        >
          {isAutoMatching ? '⏳ Matching...' : '🎯 Auto-Match'}
        </button>
        
        <button
          className="mapper-toolbar__button"
          onClick={onClearAll}
          disabled={mappingCount === 0}
        >
          🗑️ Clear All
        </button>
        
        <button
          className="mapper-toolbar__button mapper-toolbar__button--primary"
          onClick={onValidate}
        >
          ✓ Validate
        </button>
      </div>
      
      <div className="mapper-toolbar__right">
        <span className="mapper-toolbar__count">
          {mappingCount} {mappingCount === 1 ? 'mapping' : 'mappings'}
        </span>
        
        {validation && (
          <span className={`mapper-toolbar__status mapper-toolbar__status--${validation.valid ? 'valid' : 'invalid'}`}>
            {validation.valid ? '✅ Valid' : '❌ Invalid'}
          </span>
        )}
      </div>
    </div>
  );
};
